import { render, staticRenderFns } from "./CircleItem.vue?vue&type=template&id=53013d1c&scoped=true&"
import script from "./CircleItem.vue?vue&type=script&lang=js&"
export * from "./CircleItem.vue?vue&type=script&lang=js&"
import style0 from "./CircleItem.vue?vue&type=style&index=0&id=53013d1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53013d1c",
  null
  
)

export default component.exports